(function($) {
    //блок conveyor
    let $el = $(".js-conveyor");

    if (!$el.length) return;

    let delay = 2000;
    let duration = 1000;
    let $items = $el.children();
    // let stepLength = $el.innerWidth() / $items.length;
    let stepLength = (52 * $el.innerWidth() / 296) / $el.innerWidth() * 100;
    let isAnimated = false;

    // console.log(stepLength);

    setItemsPosition();
    // carousel();
    $(".js-registrator__last").one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', startAnimation);

    function startAnimation(e) {
        if (!isAnimated) {
            console.log("start animation");
            $items.addClass("conveyor__image_notransition");
            $(".js-registrator__line_animate").addClass("is-infinite");
            // $items.css("transition-delay", 0);
            // $items.each(function() {
            //     $(this).css("transition-delay", 0);
            // });
            carousel();
            isAnimated = true;
        }
    };

    function setItemsPosition() {
        //расставляет элементы по позициям
        for (let i = 0; i < $items.length; i++) {
            $($items[i]).css("left", stepLength * i + "%");
        }
    };

    function carousel() {
        //запускает рекурсивно анимацию перемещения
        setTimeout(() => {
            moveItems();
            carousel();
        }, delay);
    }

    function moveItems() {
        //один шаг анимации
        let $items = $el.children();

        let lastItem = $items[$items.length - 1];
        let clone = $(lastItem).clone();

        moveSingleItem(lastItem, true);
        addItem(clone);

        for (let i = 0; i < ($items.length - 1); i++) {
            moveSingleItem($items[i]);
        }
    }

    function addItem(item) {
        //добавляет в начало элемент item
        $(item).css({ left: -stepLength + "%", opacity: 0 })
            .prependTo($el)
            .animate({
                left: 0,
                opacity: 1
            }, {
                duration: duration
            });
    }

    function moveSingleItem(item, isLast) {
        //двигает элемемент item и удаляет его если отмечен параметр isLast
        let leftStartPx = parseInt($(item).css("left"));
        let leftStartPercent = leftStartPx / $el.innerWidth() * 100;
        let leftEnd = leftStartPercent + stepLength;

        if (isLast) {
            $(item)
                .animate({
                    opacity: 0
                }, {
                    queue: false,
                    duration: duration / 2
                })
                .animate({
                    left: leftEnd + "%",
                    // opacity: 0
                }, {
                    duration: duration,
                    complete: function() {
                        $(this).remove();
                    }
                });
        } else {
            $(item).animate({
                left: leftEnd + "%"
            }, {
                duration: duration
            });
        }
    };
})(jQuery);



// WEBPACK FOOTER //
// ./common.blocks/conveyor/conveyor.js